/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Taggroups_Accessibility1Inputs */

const id_search_taggroups_accessibility1 = /** @type {(inputs: Search_Taggroups_Accessibility1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aksesibilitas`)
};

const ms_search_taggroups_accessibility1 = /** @type {(inputs: Search_Taggroups_Accessibility1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kebolehcapaian`)
};

const da_search_taggroups_accessibility1 = /** @type {(inputs: Search_Taggroups_Accessibility1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilgængelighed`)
};

const de_search_taggroups_accessibility1 = /** @type {(inputs: Search_Taggroups_Accessibility1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barrierefreiheit`)
};

const en_us2_search_taggroups_accessibility1 = /** @type {(inputs: Search_Taggroups_Accessibility1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accessibility`)
};

const es_es2_search_taggroups_accessibility1 = /** @type {(inputs: Search_Taggroups_Accessibility1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accesibilidad`)
};

const es_mx2_search_taggroups_accessibility1 = /** @type {(inputs: Search_Taggroups_Accessibility1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accesibilidad`)
};

const fil_search_taggroups_accessibility1 = /** @type {(inputs: Search_Taggroups_Accessibility1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accessibility`)
};

const fr_search_taggroups_accessibility1 = /** @type {(inputs: Search_Taggroups_Accessibility1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accessibilité`)
};

const it_search_taggroups_accessibility1 = /** @type {(inputs: Search_Taggroups_Accessibility1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accessibilità`)
};

const hu_search_taggroups_accessibility1 = /** @type {(inputs: Search_Taggroups_Accessibility1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akadálymentesítés`)
};

const nl_search_taggroups_accessibility1 = /** @type {(inputs: Search_Taggroups_Accessibility1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toegankelijkheid`)
};

const no_search_taggroups_accessibility1 = /** @type {(inputs: Search_Taggroups_Accessibility1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilgjengelighet`)
};

const pl_search_taggroups_accessibility1 = /** @type {(inputs: Search_Taggroups_Accessibility1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dostępność`)
};

const pt_br2_search_taggroups_accessibility1 = /** @type {(inputs: Search_Taggroups_Accessibility1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acessibilidade`)
};

const pt_search_taggroups_accessibility1 = /** @type {(inputs: Search_Taggroups_Accessibility1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acessibilidade`)
};

const ro_search_taggroups_accessibility1 = /** @type {(inputs: Search_Taggroups_Accessibility1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accesibilitate`)
};

const fi_search_taggroups_accessibility1 = /** @type {(inputs: Search_Taggroups_Accessibility1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saavutettavuus`)
};

const sv_search_taggroups_accessibility1 = /** @type {(inputs: Search_Taggroups_Accessibility1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tillgänglighet`)
};

const vi_search_taggroups_accessibility1 = /** @type {(inputs: Search_Taggroups_Accessibility1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trợ năng`)
};

const tr_search_taggroups_accessibility1 = /** @type {(inputs: Search_Taggroups_Accessibility1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erişilebilirlik`)
};

const cs_search_taggroups_accessibility1 = /** @type {(inputs: Search_Taggroups_Accessibility1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přístupnost`)
};

const bg_search_taggroups_accessibility1 = /** @type {(inputs: Search_Taggroups_Accessibility1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Достъпност`)
};

const ru_search_taggroups_accessibility1 = /** @type {(inputs: Search_Taggroups_Accessibility1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доступность`)
};

const uk_search_taggroups_accessibility1 = /** @type {(inputs: Search_Taggroups_Accessibility1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доступність`)
};

const ar_search_taggroups_accessibility1 = /** @type {(inputs: Search_Taggroups_Accessibility1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إمكانية الوصول`)
};

const hi_search_taggroups_accessibility1 = /** @type {(inputs: Search_Taggroups_Accessibility1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक्सेसिबिलिटी`)
};

const th_search_taggroups_accessibility1 = /** @type {(inputs: Search_Taggroups_Accessibility1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การเข้าถึง`)
};

const ja_search_taggroups_accessibility1 = /** @type {(inputs: Search_Taggroups_Accessibility1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクセシビリティ`)
};

const zh_cn2_search_taggroups_accessibility1 = /** @type {(inputs: Search_Taggroups_Accessibility1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无障碍`)
};

const zh_hant1_search_taggroups_accessibility1 = /** @type {(inputs: Search_Taggroups_Accessibility1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無障礙`)
};

const ko_search_taggroups_accessibility1 = /** @type {(inputs: Search_Taggroups_Accessibility1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`접근성`)
};

/**
* | output |
* | --- |
* | "Accessibility" |
*
* @param {Search_Taggroups_Accessibility1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const search_taggroups_accessibility1 = /** @type {((inputs?: Search_Taggroups_Accessibility1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Taggroups_Accessibility1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_search_taggroups_accessibility1(inputs)
	if (locale === "ms") return ms_search_taggroups_accessibility1(inputs)
	if (locale === "da") return da_search_taggroups_accessibility1(inputs)
	if (locale === "de") return de_search_taggroups_accessibility1(inputs)
	if (locale === "en-US") return en_us2_search_taggroups_accessibility1(inputs)
	if (locale === "es-ES") return es_es2_search_taggroups_accessibility1(inputs)
	if (locale === "es-MX") return es_mx2_search_taggroups_accessibility1(inputs)
	if (locale === "fil") return fil_search_taggroups_accessibility1(inputs)
	if (locale === "fr") return fr_search_taggroups_accessibility1(inputs)
	if (locale === "it") return it_search_taggroups_accessibility1(inputs)
	if (locale === "hu") return hu_search_taggroups_accessibility1(inputs)
	if (locale === "nl") return nl_search_taggroups_accessibility1(inputs)
	if (locale === "no") return no_search_taggroups_accessibility1(inputs)
	if (locale === "pl") return pl_search_taggroups_accessibility1(inputs)
	if (locale === "pt-BR") return pt_br2_search_taggroups_accessibility1(inputs)
	if (locale === "pt") return pt_search_taggroups_accessibility1(inputs)
	if (locale === "ro") return ro_search_taggroups_accessibility1(inputs)
	if (locale === "fi") return fi_search_taggroups_accessibility1(inputs)
	if (locale === "sv") return sv_search_taggroups_accessibility1(inputs)
	if (locale === "vi") return vi_search_taggroups_accessibility1(inputs)
	if (locale === "tr") return tr_search_taggroups_accessibility1(inputs)
	if (locale === "cs") return cs_search_taggroups_accessibility1(inputs)
	if (locale === "bg") return bg_search_taggroups_accessibility1(inputs)
	if (locale === "ru") return ru_search_taggroups_accessibility1(inputs)
	if (locale === "uk") return uk_search_taggroups_accessibility1(inputs)
	if (locale === "ar") return ar_search_taggroups_accessibility1(inputs)
	if (locale === "hi") return hi_search_taggroups_accessibility1(inputs)
	if (locale === "th") return th_search_taggroups_accessibility1(inputs)
	if (locale === "ja") return ja_search_taggroups_accessibility1(inputs)
	if (locale === "zh-CN") return zh_cn2_search_taggroups_accessibility1(inputs)
	if (locale === "zh-Hant") return zh_hant1_search_taggroups_accessibility1(inputs)
	return ko_search_taggroups_accessibility1(inputs)
});
export { search_taggroups_accessibility1 as "search.tagGroups.accessibility" }